export enum GRAPHQL_TYPENAMES {
  ANALYTICS_METRIC = 'AnalyticsMetric',
  ANCESTOR = 'Ancestor',
  CAMPAIGN = 'Campaign',
  CAMPAIGN_FOLDER = 'CampaignFolder',
  CAMPAIGN_SUBFOLDER = 'CampaignSubfolder',
  CONVERSION = 'ConversionDefinition',
  CONVERSIONS = 'Conversions',
  CONVERSION_EVENT = 'ConversionEventDefinition',
  CUSTOM_CONVERSION = 'CustomConversion',
  INFO = 'Info',
  SNIPPET = 'Snippet',
  TEMPLATE = 'Template',
  TEMPLATE_FOLDER = 'TemplateFolder',
  TEMPLATE_SUBFOLDER = 'Subfolder',
  TEMPLATE_AND_CONTENT = 'TemplateAndContent',
  JOURNEY = 'Workflow',
  JOURNEY_FOLDER = 'WorkflowFolder',
  JOURNEY_SUBFOLDER = 'WorkflowSubfolder',
  LIST = 'List',
  LISTS = 'Lists',
  LIST_FOLDER = 'ListFolder',
  LIST_SUBFOLDER = 'ListSubfolder',
  LIST_USAGE_RESULTS = 'ListUsageResults',
  LOCALE = 'Locale',
  USER = 'User',
  USER_CONTEXT = 'UserContext',
  USER_BETA_FEATURE = 'UserBetaFeatureDefinition',
  PROJECT_FEATURE = 'ProjectFeatureDefinition',
  IMAGE_ASSET = 'ImageAsset',
  ASSET_SUBFOLDER = 'AssetSubfolder',

  // saved rows
  BEE_ROW_UPDATE_FAILURE = 'BeeRowUpdateFailure',
  BEE_SAVED_ROW_DELETION_FAILURE = 'BeeSavedRowDeletionFailure',
  BEE_SAVED_ROW_CREATION_FAILURE = 'BeeSavedRowCreationFailure',
  BEE_CREATE_FIELD_NOT_PROVIDED = 'BeeCreateFieldNotProvided',
  BEE_CREATE_FIELD_TOO_LONG_FAILURE = 'BeeCreateFieldTooLongFailure',
  BEE_ROW_NOT_FOUND = 'BeeRowNotFound',
  BEE_FIELD_INVALID_FAILURE = 'BeeFieldInvalidFailure',
  BEE_ROW_NAME_ALREADY_EXISTS_FAILURE = 'BeeRowNameAlreadyExistsFailure',
  BEE_SAVED_ROW_MUTATION_FAILURE = 'BeeSavedRowMutationFailure',
  MESSAGE_CATEGORY_UPDATE_FAILURE = 'MessageCategoryUpdateFailure',
  MESSAGE_CATEGORY_DELETION_FAILURE = 'MessageCategoryDeletionFailure',
  MANAGE_MESSAGE_CATEGORIES_FAILURE = 'ManageMessageCategoriesFailure',
  MESSAGE_CATEGORY_CREATION_FAILURE = 'MessageCategoryCreationFailure',
  MESSAGE_CATEGORY_MAXIMUM_COUNT_EXCEEDED_FAILURE = 'MessageCategoryMaximumCountExceededFailure',
  MESSAGE_CATEGORY_NAME_ALREADY_EXISTS_FAILURE = 'MessageCategoryNameAlreadyExistsFailure',
  MESSAGE_CATEGORY_NAME_EMPTY_FAILURE = 'MessageCategoryNameEmptyFailure',
  MESSAGE_CATEGORY_NAME_TOO_LONG_FAILURE = 'MessageCategoryNameTooLongFailure',

  // WhatsApp
  IMAGE_HEADER = 'ImageHeader',
  TEXT_HEADER = 'TextHeader',
  URL_BUTTON = 'UrlButton',
  CALL_BUTTON = 'CallButton',
  QUICK_REPLY_BUTTON = 'QuickReplyButton',
}

export type GraphQLTypeNameData<GraphQLTypeName extends GRAPHQL_TYPENAMES> = {
  __typename: GraphQLTypeName;
};

export type DataWithGraphQLTypeName<
  GraphQLTypeName extends GRAPHQL_TYPENAMES,
  Data extends Record<any, unknown>,
> = Data & GraphQLTypeNameData<GraphQLTypeName>;
